const group_by = (iteratee, func) => {
  const grouped = [];
  for (let [key, value] of iteratee.entries()) {
    const { id, title } = func(value, key);
    const item = grouped.find(val => val.id === id);
    if (item) {
      console.assert(item.title === title);
      item.items.push(value);
    } else {
      grouped.push({ id, title, items: [value] });
    }
  }
  return grouped;
};
export default group_by;
